// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"730":"09b7bb92","787":"2b2e7419"}[chunkId] + ".chunk.js";
};